import Vue from "vue";
import Router from "vue-router";

import Login from "./views/Login.vue";
import Users from "./views/Users.vue";
import PowerUserAllocation from "./views/PowerUserAllocation.vue";
import Factories from "./views/Factories.vue";
import Dashboard from "./views/Dashboard.vue";
import RightGroups from "./views/RightGroups.vue";
import Categories from "./views/Categories.vue";
import Products from "./views/Products.vue";
import EmailTemplates from "./views/EmailTemplates.vue";
import MyStocks from "./views/MyStocks.vue";
import MyOrders from "./views/MyOrders.vue";
import Feedback from "./views/Feedback.vue";
import RequestAccess from "./views/RequestAccess.vue";

import Report_Orders from "./views/reports/Orders.vue";
import Report_Offers from "./views/reports/Offers.vue";
import Report_LazyUsers from "./views/reports/LazyUsers.vue";
import Report_LastStockUpdate from "./views/reports/LastStockUpdate.vue";
import Report_UnorderedProducts from "./views/reports/UnorderedProducts.vue";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(Router);
Vue.use(BootstrapVue);

export default new Router({
	routes: [
		{
			path: "/",
			name: "login",
			component: Login
		},
		{
			path: "/dashboard",
			name: "dashboard",
			component: Dashboard
		},
		{
			path: "/request-access",
			name: "request-access",
			component: RequestAccess
		},
		{
			path: "/users",
			name: "users",
			component: Users
		},
		{
			path: "/power-user-allocation",
			name: "power-user-allocation",
			component: PowerUserAllocation
		},
		{
			path: "/factories",
			name: "factories",
			component: Factories
		},
		{
			path: "/right-groups",
			name: "right-groups",
			component: RightGroups
		},
		{
			path: "/product-categories",
			name: "product-categories",
			component: Categories
		},
		{
			path: "/products",
			name: "products",
			component: Products
		},
		{
			path: "/email-templates",
			name: "email-templates",
			component: EmailTemplates
		},
		{
			path: "/my-stocks",
			name: "my-stocks",
			component: MyStocks
		},
		{
			path: "/my-orders",
			name: "my-orders",
			component: MyOrders
		},
		{
			path: "/reports-orders",
			name: "reports-orders",
			component: Report_Orders
		},
		{
			path: "/reports-offers",
			name: "reports-offers",
			component: Report_Offers
		},
		{
			path: "/reports-lazy-users",
			name: "reports-lazy-users",
			component: Report_LazyUsers
		},
		{
			path: "/feedback/:id",
			name: "feedback",
			component: Feedback
		},
		{
			path: "/reports-last-stock-update",
			name: "Report_LastStockUpdate",
			component: Report_LastStockUpdate
		},
		{
			path: "/report-unordered-products",
			name: "Report_UnorderedProducts",
			component: Report_UnorderedProducts
		}
	]
});
